module.exports = ['component.indexes.record', 'component.indexes.average'];
